import { filterOptionRowClass } from '../../filter-panel.css';

export const optionRowClass = filterOptionRowClass;
